import React from "react";
import {useSearchParams} from "react-router-dom";
import CouponList from "../../components/event/CouponList";
import CouponUsageList from "../../components/event/CouponUsageList";
import Box from "../../components/UI/Box";

const COUPON_VIEW_COUPONS = 'coupons';
const COUPON_VIEW_USAGES = 'usages';

// The active view lives in the URL so a coupon's usages can be linked to and survive a reload.
const VIEWS = [
    {id : COUPON_VIEW_COUPONS, name : 'Coupons'},
    {id : COUPON_VIEW_USAGES, name : 'Usages'}
];

const CouponsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const requestedView = searchParams.get('view');
    const view = VIEWS.some((option) => option.id === requestedView)
        ? requestedView
        : COUPON_VIEW_COUPONS;

    const handleViewClick = (nextView) => {
        setSearchParams({view : nextView});
    };

    return <Box>
        <div className="flex gap-2 border-b border-gray-200">
            {VIEWS.map((option) => (
                <button
                    key={option.id}
                    type="button"
                    onClick={() => handleViewClick(option.id)}
                    className={`-mb-px border-b-2 px-4 py-2 text-sm font-semibold transition-colors hover:cursor-pointer ${
                        view === option.id
                            ? 'border-pink-600 text-pink-600'
                            : 'border-transparent text-gray-500 hover:text-gray-900'
                    }`}
                >
                    {option.name}
                </button>
            ))}
        </div>
        {view === COUPON_VIEW_USAGES ? <CouponUsageList/> : <CouponList/>}
    </Box>
}

export default CouponsPage;
